export default "__VITE_ASSET__CXWl60jx__"